import { PaymentForm, RecurringPaymentForm, PaymentPeriod, PaymentType, PaymentAmountType, AccountType } from '../models/payment.model';
import { RecurringPaymentDetailsDto } from '../models/dtos/recurring-payment-details.dto';

/**
 * Mapper for converting between RecurringPaymentForm and RecurringPaymentDetailsDto
 */
export class RecurringPaymentDetailsMapper {
  /**
   * Maps RecurringPaymentForm to RecurringPaymentDetailsDto
   */
  static toDto(form: RecurringPaymentForm): RecurringPaymentDetailsDto {
    return {
      status: 1, // Default status, adjust as needed
      amount_fixed: form.amount !== null && form.amount !== undefined ? form.amount.toString() : undefined,
      billing_type: form.type === PaymentType.Card ? 1 : 2, // Example: 1=Card, 2=Bank
      billing_start_date: form.dateRange?.start ? form.dateRange.start.toISOString().slice(0, 10) : '',
      billing_expire_date: form.dateRange?.end ? form.dateRange.end.toISOString().slice(0, 10) : undefined,
      billing_period: form.period ?? PaymentPeriod.OneTime,
      account_number: form.accountNumber,
      aba_number: form.routingNumber,
    };
  }

  /**
   * Maps RecurringPaymentDetailsDto to RecurringPaymentForm
   */
  static toForm(dto: RecurringPaymentDetailsDto): RecurringPaymentForm {
    return {
      loanId: dto.row_id!,
      amount: dto.amount_fixed ? +dto.amount_fixed : null,
      type: dto.billing_type === 1 ? PaymentType.Card : PaymentType.Bank,
      isRecurring: true,
      billRegularAmount: dto.amount_fixed ? dto.amount_fixed === '0' : false,
      accountNumber: dto.account_number,
      routingNumber: dto.aba_number,
      dateRange: {
        start: dto.billing_start_date ? new Date(dto.billing_start_date) : null,
        end: dto.billing_expire_date ? new Date(dto.billing_expire_date) : null,
      },
      period: dto.billing_period as PaymentPeriod,
      // The following fields are not present in the DTO and will be left undefined
      cardNumber: undefined,
      cardExpiry: undefined,
      cardCvv: undefined,
      accountType: undefined,
      amountType: undefined,
    };
  }
}
